'use client';

import type { MailSuccessProps } from './model';
import { VpButton } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';

export const MailSuccess = ({ closeModal }: MailSuccessProps) => {
  const t = useTranslations('CONTACT_DIALOG');

  return (
    <div className="popin__description">
      <div className="popin__title vp-title-m">{t('TITLE')}</div>
      <p>{t('TITLE_2')}</p>
      <div className="popin__action">
        <VpButton onClick={closeModal}>{t('CLOSE')}</VpButton>
      </div>
    </div>
  );
};
